import { ExtendedProvider, Profile } from 'Src/types';

export const convertProfilesToProviders = (
  profiles: Profile[],
  locationId: string
): ExtendedProvider[] => {
  return profiles.map((profile: Profile) => {
    const location = profile.locations?.find(
      (loc) => String(loc.primary_marketable_location_id) === String(locationId)
    );
    return {
      ...profile.provider,
      locations: location ? [location] : [],
      has_provider_availability: !!profile.availability?.slots?.length
    };
  });
};
